import { render, staticRenderFns } from "./basic_primarylist.vue?vue&type=template&id=fd986f9a&scoped=true"
import script from "./basic_primarylist.vue?vue&type=script&lang=js"
export * from "./basic_primarylist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd986f9a",
  null
  
)

export default component.exports